import { useEffect } from 'react';

import { useUnifiedUserStatus } from '../hooks/useUnifiedUserStatus';
import { EModalContent, useModalStore } from '../ModalProvider';

export const UnifiedUserIssueResolver = () => {
  const { unifiedUser } = useUnifiedUserStatus();
  const modalStore = useModalStore();

  useEffect(() => {
    // Only launch modal when we have unified user data
    if (!unifiedUser) {
      return;
    }

    const { firstName, lastName, unifiedPhoneStatus, phone } = unifiedUser;
    const { number } = phone || {};
    const { hasConflict } = unifiedPhoneStatus || {};

    // Check if the modal is already open
    const currentModal = modalStore.lookup();
    if (currentModal?.name === EModalContent.UNIFIED_USER_PHONE_VERIFICATION) {
      if (!hasConflict && !firstName && !lastName) {
        modalStore.clear();
      }
      return;
    }

    if (hasConflict || !firstName || !lastName) {
      modalStore.navigate({
        name: EModalContent.UNIFIED_USER_PHONE_VERIFICATION,
        issue: {
          type: 'debug',
          severity: 'info',
          message: 'Debug modal - showing unified user information',
          phoneNumber: number || undefined,
        },
      });
    }
  }, [unifiedUser, modalStore]); // Depend on unified user data

  return null;
};
